import React, { useEffect, useState } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { AUTHENTICATED_ENTRY, AUTHENTICATED_CONTABILITA_ENTRY } from 'configs/AppConfig'

const PublicRoute = () => {
	// Prelevare direttamente dallo state per essere sicuri di avere l'ultimo valore
	const token = useSelector(state => state.auth.token);
	const ruolo = useSelector(state => state.auth.ruolo);
	const centro_in_uso = useSelector(state => state.auth.centro_in_uso);

	const [entryRoute, setEntryRoute] = useState(null);
	const expirationDate = token != null ? new Date(JSON.parse(atob(token?.split('.')[1])).exp * 1000) : null;
	const currentDate = new Date();

	// Aggiorniamo entryRoute quando cambia centro_in_uso o ruolo
	useEffect(() => {
		console.log("PublicRoute - centro_in_uso CAMBIATO:", centro_in_uso);
		console.log("PublicRoute - ruolo:", ruolo);

		if (ruolo) {
			let valueEntry = AUTHENTICATED_ENTRY;

			if (ruolo && ruolo.name === 'contabile') {
				valueEntry = AUTHENTICATED_CONTABILITA_ENTRY;
			} else {
				if (centro_in_uso === 'centro_contabile') {
					valueEntry = AUTHENTICATED_CONTABILITA_ENTRY;
				} else if (centro_in_uso === 'centro_medico') {
					valueEntry = AUTHENTICATED_ENTRY;
				}
			}
			console.log("PublicRoute - valueEntry:", valueEntry);
			setEntryRoute(valueEntry);
		}
	}, [centro_in_uso, ruolo]);

	return (token && currentDate <= expirationDate) ? <Navigate to={entryRoute} /> : <Outlet />
}

export default PublicRoute